import { ConvertableFromApi } from "./ConvertableFromApi";
import { WorkspaceItem } from "./WorkspaceItem";
import { GraphUserModel } from "./GraphUserModel";
import {VirtualMachine} from './VirtualMachine';
import { Budget } from './Budget';
import RequestHistoryLine from "./RequestHistoryLine";

export class WorkspaceDetails extends ConvertableFromApi<WorkspaceDetails> {
  
  workspaceItems!: WorkspaceItem[];
  researchers!: GraphUserModel[] ;
  requestHistoryLines!: RequestHistoryLine[];
  owners!: GraphUserModel[];
  workspaceId!: string;
  groupId!: string;
  tenantName!: string;
  virtualMachines!: VirtualMachine[];
  isOwner!: boolean;
  budget!: Budget;
  workspaceStatus!: string;
  budgetStatus!: string;
  public tags!: Map<string, string>;
  public isDisabled!: boolean;
  budgetMostRecentlySyncedOn!: string;
  vmSetUpdateInProgress!: boolean;

  constructor(data?: any) {
    super(data);
    if(!this.objectFromApi){
      return;
    }
    
    if(this.objectFromApi.workspaceItems){
      this.workspaceItems = [];
      this.objectFromApi.workspaceItems.forEach((item: any) => {
        this.workspaceItems.push(new WorkspaceItem(item));
      });
    }
    this.researchers = this.objectFromApi.researchers;
    this.budgetMostRecentlySyncedOn = this.objectFromApi.budgetMostRecentlySyncedOn;
    this.requestHistoryLines = this.objectFromApi.requestHistoryLines;
    this.owners = this.objectFromApi.owners;
    this.groupId = this.objectFromApi.groupId;
    this.workspaceId = this.objectFromApi.workspaceId;
    this.tags = new Map<string,string>(Object.entries(this.objectFromApi.tags));
    this.tenantName = this.objectFromApi.tenantName;
    this.isOwner = this.objectFromApi.isOwner;
    this.virtualMachines = [];
    this.isDisabled = this.tags.has("IsRemovedAt");
    this.objectFromApi.virtualMachines.forEach((vm: any) => {
      this.virtualMachines.push(new VirtualMachine(vm));
    });
    this.budget = new Budget(this.objectFromApi.budget);
    this.workspaceStatus = this.objectFromApi.workspaceStatus;
    this.budgetStatus = this.objectFromApi.budgetStatus;
    this.vmSetUpdateInProgress = this.objectFromApi.vmSetUpdateInProgress;
  }

  createNew(element: any): WorkspaceDetails {
    return new WorkspaceDetails(element);
  }

  // must be static to allow mutations of store's data-only workspace object
  public static getVmMap(ws: WorkspaceDetails): Map<string, VirtualMachine> {
    var vmMap = new Map<string, VirtualMachine>();
    if (ws.virtualMachines) {
      ws.virtualMachines.forEach((vm: VirtualMachine) => {
        vmMap.set(vm.name, vm);
      });
    }

    return vmMap;
  }

  // must be static to allow mutations of store's data-only workspace object
  public static fixVmStates(ws: WorkspaceDetails, oldVmMap: Map<string, VirtualMachine>, vmUpdateStateHoldInterval: number) {
    ws.virtualMachines.forEach((vm) => {
      var oldVm = oldVmMap.get(vm.name);
      // needed only if VM sizes are dynamic;
      // must be aligned with WorkspaceDetailsService.GetVirtualMachineSizeTypes
      // that (used to) returns empty set when there is an update op running
      vm.fixVmSize(oldVm);

      if (!oldVm || oldVm.powerState == vm.powerState) {
        // VM state unchanged
        vm.log();
        return;
      }

      vm.log("(new state), old state", oldVm.powerState);

      // keep "Starting" or "Deleting" for a while
      if (oldVm.powerState == "VM starting"  && vm.powerState != "VM running")
        VirtualMachine.fixUpdateState(vm, oldVm, vmUpdateStateHoldInterval);
      if (oldVm.powerState == "Deleting")
        VirtualMachine.fixUpdateState(vm, oldVm, vmUpdateStateHoldInterval);
    });

    // copy VM being created
    // probably not needed as we don't get the name of the new VM
    for (const [name, oldVm] of oldVmMap) {
      if (oldVm.powerState === "Creating" && !!oldVm.name) {
        const exists = ws.virtualMachines.some(x => x.name === oldVm.name);
        if (exists)
          continue;
        // wait up to 9 refresh intervals in case VM deployment takes loong time
        if (Date.now() - oldVm.stateUpdatedAt > 3 * vmUpdateStateHoldInterval) {
          oldVm.log("on hold canceled");
          continue;
        }

        oldVm.log("keeping on hold");
        ws.virtualMachines.push(oldVm);
      }
    }
  }
}
